<div class="tw-border tw-border-[#dedede] tw-rounded-3 tw-m-4 tw-p-4" (click)="openPriceDetailSheet()">
  <div class="tw-flex tw-items-center tw-justify-between">
    <p class="tw-text-400 tw-font-lexend tw-font-bold tw-text-gray-800 tw-capitalize" i18n="@@toPay">To pay</p>
    <div class="tw-flex tw-items-center">
      <p class="tw-text-300 tw-opacity-50 tw-line-through">₹{{pricingDetails().totalMrp}}</p>&nbsp;
      <p class="tw-pr-[6px]">₹{{pricingDetails().totalSP}}</p>
      <cs-icon class="tw-h-4 tw-w-4 tw-text-teal-600 tw-rotate-90 tw-pl-1.5" [iconName]="'chevron_right_teal'"></cs-icon>
    </div>
  </div>
  <div class="tw-flex tw-items-center tw-gap-1">
    <div class="tw-relative">
      <img src="/assets/icons/rebranded-orange-discount.svg" alt="percentage bg savings" class="tw-w-4 tw-h-4"/>
      <p class="tw-absolute tw-top-[1px] tw-right-[23%] tw-font-body tw-text-center tw-font-bold tw-text-[9px] tw-text-white">%</p>
    </div>
    <span class="tw-text-gray-500 tw-font-body tw-text-200 tw-font-medium tw-opacity-[0.98]" i18n="@@youAreSavingAmount">
      You are saving <span class="tw-text-orange-500 tw-font-body tw-text-200 tw-font-bold">₹{{pricingDetails().discountInRupees}}</span>
    </span>
  </div>
</div>
